export default __webpack_public_path__ + "static/media/white02.9fa31c1b.jpg";